export default function getPageTitle(pageTitle) {
  const title = '繁星联盟'
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return title
}

// 判断是否有权限

export function judgePower(arr, str) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === str) {
      return true
    }
  }
  return false
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 数字千分位格式化  用逗号分割
 * @date 2020-01-08
 * @param {any} num  5000000
 * @returns {any} num  5,000,000
 */
export function numFormat(num) {
  const c = (num.toString().indexOf('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  return c
}

function format(num) {
  let str = "";
  str = (Math.round((num + 3e-16) * 100) / 100)
    .toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
      return $1 + ",";
    });
  return str;
}

// 千分号分割,2位小数
export const formatNumberRgx2 = (num) => {
  // const newNum = Number(num).toFixed(2);
  const newNum = format(Number(num))
  var parts = newNum.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

// 判断是否是 合法url
export function isUrl(path) {
  const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
  return reg.test(path)
}

// 将时间戳转化为日期
export const timestampToDate = (timestamp) => {
  if (!timestamp) return null;
  const myDate = new Date(timestamp);
  const year = myDate.getFullYear();
  const month = (myDate.getMonth() + 1) < 10 ? "0" + (myDate.getMonth() + 1) : myDate.getMonth() + 1;
  const day = myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate();
  return `${year}-${month}-${day}`;
}

// object去空
export const delUndefined = function (ob) {
  for (const e in ob) {
    if (typeof (ob[e]) === 'undefined' || ob[e] === null || ob[e] === 'NaN' || ob[e] === '') {
      delete ob[e];
    } else if (ob[e].constructor === Object) {
      if (Object.keys(ob[e]).length === 0) {
        delete ob[e];
      } else {
        delUndefined(ob[e]);
      }
    } else if (ob[e].constructor === Array && ob[e].length > 0) {
      ob[e].map(function (seg) {
        if (typeof (seg) === 'object') {
          delUndefined(seg);
        }
        return ob;
      });
    } else if (ob[e].constructor === Array && ob[e].length === 0) {
      delete ob[e];
    }
  }
  return ob;
}

// 相比于delUndefined方法的区别在于optionTrim不会改变数据源，返回一个新对象。
export const optionTrim = (opts) => delUndefined(Object.assign({}, opts))

// 将时间戳转化为完整日期
export const timestampToDateTotal = (timestamp) => {
  const date = new Date(timestamp);
  const Y = date.getFullYear() + "-";
  const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  const D = date.getDate() < 10 ? ("0" + date.getDate() + " ") : (date.getDate() + " ");
  const h = date.getHours() < 10 ? ("0" + date.getHours() + ":") : (date.getHours() + ":");
  const m = date.getMinutes() < 10 ? ("0" + date.getMinutes() + ":") : (date.getMinutes() + ":");
  const s = date.getSeconds() < 10 ? ("0" + date.getSeconds()) : (date.getSeconds());
  return Y + M + D + h + m + s;
}

// 获取上个月日期
export function lastMonthDate() {
  var Nowdate = new Date();
  var vYear = Nowdate.getFullYear();
  var vMon = Nowdate.getMonth() + 1;
  var vDay = 0;
  // 每个月的最后一天日期（为了使用月份便于查找，数组第一位设为0）
  var daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (vMon === 1) {
    vYear = Nowdate.getFullYear() - 1;
    vMon = 12;
  } else {
    vMon = vMon - 1;
  }
  // 若是闰年，二月最后一天是29号
  if (vYear % 4 === 0 && (vYear % 100 !== 0 || vYear % 400 === 0)) {
    daysInMonth[2] = 29;
  }
  vDay = daysInMonth[vMon];
  if (vDay < 10) {
    vDay = "0" + vDay;
  }
  if (vMon < 10) {
    vMon = "0" + vMon;
  }
  const startTime = vYear + "-" + vMon + "-" + "01";
  const endTime = vYear + "-" + vMon + "-" + vDay;
  const date = {
    startTime,
    endTime
  }
  return date;
}
// 获取当前日期
export function getCurrentMonthTime() {
  var Nowdate = new Date();
  var vYear = Nowdate.getFullYear();
  var vMon = Nowdate.getMonth() + 1;
  var vDay = Nowdate.getDate();
  // 由于safari不识别yyyy-mm-dd的格式， 统一设定为为yyyy/mm/dd的格式
  const startTime = vYear + "/" + vMon + "/" + '01';
  const endTime = vYear + "/" + vMon + "/" + vDay;
  const date = {
    startTime,
    endTime
  }
  return date;
}

// 去除数组重复对象
export function deteleObject(obj) {
  var uniques = [];
  var stringify = {};
  for (var i = 0; i < obj.length; i++) {
    var keys = Object.keys(obj[i]);
    keys.sort(function(a, b) {
      return (Number(a) - Number(b));
    });
    var str = '';
    for (var j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(obj[i][keys[j]]);
    }
    if (!Object.prototype.hasOwnProperty.call(stringify, str)) {
      uniques.push(obj[i]);
      stringify[str] = true;
    }
  }
  return uniques;
}

export function toPercentage(num) {
  const percentage = num * 100;
  return percentage ? `${percentage.toFixed(2)}%` : num;
}
